import { render } from "./DetailedProjectCommonInfo.vue?vue&type=template&id=4cc52ca0&scoped=true"
import script from "./DetailedProjectCommonInfo.vue?vue&type=script&lang=js"
export * from "./DetailedProjectCommonInfo.vue?vue&type=script&lang=js"

import "./DetailedProjectCommonInfo.vue?vue&type=style&index=0&id=4cc52ca0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc52ca0"]])

export default __exports__